<template>
    <div class="modal fade" id="modalCambiarFecha" tabindex="-1" aria-labelledby="modalCambiarFechaLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalCambiarFechaLabel">
                        <i class="fas fa-calendar fa-fw mr-1"></i> Cambiar Fecha — HC No. {{ historia_clinica.id }}
                    </h5>
                    <div class="d-flex justify-content-end mx-2">
                        <span class="badge badge-secondary-soft badge-marketing" v-if="historia_clinica.tipo_historia">
                            {{ historia_clinica.tipo_historia.nombre }}
                        </span>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex mb-3 text-muted small">
                        <span class="mr-3" v-if="historia_clinica.user">
                            <i class="fas fa-user-md fa-fw mr-1"></i> {{ historia_clinica.user.name }}
                        </span>
                        <span>
                            <i class="fas fa-calendar-alt fa-fw mr-1"></i>
                            Fecha actual: <strong>{{ historia_clinica.created_at | formatDateTime }}</strong>
                        </span>
                    </div>

                    <div class="form-group">
                        <label class="small font-weight-700 mb-1">Nueva Fecha <small>(*)</small></label>
                        <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="nueva_fecha"
                            :class="{ 'is-invalid': $v.nueva_fecha.$error && $v.nueva_fecha.$dirty }"
                        />
                        <span class="invalid-feedback" v-if="!$v.nueva_fecha.required">
                            Este campo es requerido
                        </span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success btn-sm" @click="guardar()">
                        Guardar <i class="fas fa-save fa-fw"></i>
                    </button>
                    <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">
                        Cerrar <i class="fas fa-times-circle fa-fw"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import historiaClinicaService from "../../../services/historiaClinicaService";
import $ from 'jquery';
import Toast from '../../../components/common/utilities/toast';
import { required } from "vuelidate/lib/validators";

export default {
    data() {
        return {
            nueva_fecha: '',
            historia_clinica: {}
        }
    },
    validations() {
        return {
            nueva_fecha: { required }
        }
    },
    methods: {
        async guardar() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) return;

                this.LoaderSpinnerShow();
                await historiaClinicaService.cambiarFecha({
                    id_historia: this.historia_clinica.id,
                    fecha: this.nueva_fecha
                });
                this.LoaderSpinnerHide();
                this.limpiarCampos();

                $('#modalCambiarFecha').modal('hide');
                this.$emit('fecha-cambiada');

                Toast.fire({
                    icon: 'success',
                    title: 'Fecha actualizada exitosamente'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrió un error al procesar la solicitud'
                });
            }
        },
        limpiarCampos() {
            this.nueva_fecha = '';
        },
        openModal(historia) {
            this.$nextTick(() => {
                this.historia_clinica = historia;
                console.table(historia);
                this.nueva_fecha = historia.created_at ? historia.created_at.substring(0, 10) : '';
                $('#modalCambiarFecha').modal('show');
            });
        }
    }
}
</script>
